import React from "react";
import { Button, TextField, CircularProgress } from "@mui/material";
import { useNewPassword } from "../hooks/useNewPassword";
//region [[ Styles ]]

//endregion [[ Styles ]]

//region [[ Props ]]

export interface NewPasswordFormMuiProps {
  onResetComplete: () => void;
  onError: (errMsg: string) => void;
  useSessionStorage?: boolean;
}

//endregion [[ Props ]]
export const NewPasswordFormMui = ({
  onResetComplete,
  onError,
  useSessionStorage = false,
}: NewPasswordFormMuiProps) => {
  const {
    newPasswordRequested,
    loading,
    onChange,
    onForgetPassword,
    setVerifyPassword,
    setVerificationCode,
    setEmail,
    setPassword,
    wrongPassword,
    disableSend,
  } = useNewPassword({
    onResetComplete,
    onError,
    useSessionStorage,
  });

  const handleEmailChanged = (e) => setEmail(e.target.value);

  const handlePasswordChanged = (e) => setPassword(e.target.value);

  const handleConformedPasswordChanged = (e) =>
    setVerifyPassword(e.target.value);

  const handleVerificationCodeChanged = (e) =>
    setVerificationCode(e.target.value);

  return (
    <div>
      {!newPasswordRequested && (
        <TextField
          className={"email-input"}
          fullWidth
          required
          margin="normal"
          variant="outlined"
          label="Email Address"
          type="email"
          onKeyDown={(e) => {
            if (e.key === "Enter") onForgetPassword();
          }}
          onChange={handleEmailChanged}
        />
      )}
      {newPasswordRequested && (
        <>
          <TextField
            className={"password-input"}
            fullWidth
            required
            margin="normal"
            variant="outlined"
            label="New Password"
            type="password"
            onChange={handlePasswordChanged}
          />
          <TextField
            className={"password-input repeat"}
            fullWidth
            required
            margin="normal"
            variant="outlined"
            error={wrongPassword}
            label="Confirm Password"
            type="password"
            onChange={handleConformedPasswordChanged}
          />
          <div>Enter the verification code you received in your email:</div>
          <div>
            (If you don't see the email, check the spam folder for mail from
            info@kahun.com)
          </div>
          <TextField
            fullWidth
            required
            margin="normal"
            variant={"outlined"}
            label={"Verification Code"}
            onChange={handleVerificationCodeChanged}
          />
        </>
      )}
      <Button
        variant="contained"
        fullWidth
        color={"primary"}
        onClick={() => (newPasswordRequested ? onChange() : onForgetPassword())}
        disabled={disableSend}
        className="submit-button"
      >
        {loading ? (
          <CircularProgress size={20} />
        ) : newPasswordRequested ? (
          "Change Password"
        ) : (
          "Forgot Password"
        )}
      </Button>
    </div>
  );
};
